import React from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'

const SellMoreScreen = ({ bottomLine=false }) => {
  return (
    <Screen
      id='sell_more_with_us'
      title={<span><StyledScreen.GreenText>Продавайте</StyledScreen.GreenText> больше с onlinepbx</span>}
      bottomLine={bottomLine}
    >
      <Styled.FormContainer>
        <Form free text='Подключить' pageName='Главная' />
      </Styled.FormContainer>
    </Screen>
  )
}

export { SellMoreScreen }
